import React, { useMemo, useState } from 'react';
import './feed.css';

const PAGE_SIZE = 3;

export default function JGKTopModal({ open, onClose, leaders = [], loading }) {
  const [page, setPage] = useState(0);

  const paged = useMemo(() => {
    const start = page * PAGE_SIZE;
    return leaders.slice(start, start + PAGE_SIZE);
  }, [leaders, page]);

  if (!open) return null;

  const totalPages = Math.max(1, Math.ceil(leaders.length / PAGE_SIZE));
  const canPrev = page > 0;
  const canNext = page < totalPages - 1;

  return (
    <div className="feedModalBackdrop" onClick={onClose}>
      <div
        className="feedModal"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="feedModalHeader">
          <div>
            <div className="feedModalTitle">JGK Top 10</div>
            <div className="feedModalSubtitle">Rotating 3 at a time</div>
          </div>
          <button className="feedModalClose" onClick={onClose}>
            ×
          </button>
        </div>

        {loading ? (
          <div className="feedModalBody">Loading leaders…</div>
        ) : (
          <div className="feedModalBody">
            {paged.map((p, idx) => (
              <div key={p._id || idx} className="jgkModalRow">
                <span className="jgkModalRank">{page * PAGE_SIZE + idx + 1}</span>
                <img
                  src={
                    p.profilePhoto ||
                    'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                  }
                  alt={p.playerId}
                  className="jgkModalAvatar"
                />
                <div className="jgkModalId">{p.playerId}</div>
                <div className="jgkModalScore">
                  {Number(p.jgkTokens || 0).toLocaleString('en-US', {
                    maximumFractionDigits: 0,
                  })}
                </div>
              </div>
            ))}
            {!paged.length && <div>No leaders yet.</div>}
          </div>
        )}

        <div className="feedModalFooter">
          <button
            className="feedModalNav"
            onClick={() => setPage((p) => Math.max(0, p - 1))}
            disabled={!canPrev}
          >
            Prev
          </button>
          <div className="feedModalPager">
            {page + 1} / {totalPages}
          </div>
          <button
            className="feedModalNav"
            onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
            disabled={!canNext}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
